import React from 'react';
import {
  Route,
  Redirect,
  Switch,
  useRouteMatch,
} from 'react-router-dom';

import CoachToolsRoute from '../ToolsRoute';
import routes from './routes';
import { getTabPath, MealPlannerType } from './mealPlannerPages';

const MealPlannerRoutes = () => {
  const { path, url } = useRouteMatch();

  return (
    <Switch>
      {routes.map(({
        pageId,
        mealPlanPath,
        component,
      }) => (
        <CoachToolsRoute
          key={pageId}
          pageId={pageId}
          path={`${path}/${mealPlanPath}`}
          component={component}
        />
      ))}

      <Route exact path={`${path}`}>
        <Redirect to={{ pathname: `${url}/${getTabPath(MealPlannerType.CLIENT_MEAL_ASSIGNMENTS)}` }} />
      </Route>
    </Switch>
  );
};

export default MealPlannerRoutes;
